// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"d659a63a","61":"c28ac2f7","130":"79cee50a","486":"1632aa8f","841":"bbf43c0e"}[chunkId] + ".chunk.js";
};